var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRepost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "13px",
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDFF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Guide",
    transform: "translate(-68.000000, -1069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(66.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/repost",
    transform: "translate(0.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,16 L13.865515,16 C14.0781216,16 14.2766198,16.1436341 14.3943155,16.3826421 L15.4646094,18.5561188 C15.4876883,18.6029856 15.5,18.658009 15.5,18.7142857 C15.5,18.8720814 15.4052377,19 15.2883426,19 L6.12466631,19 L4.87533369,19 C4.39190024,19 4,18.6430177 4,18.2026578 L4,12 L2.45684762,12 C2.20453764,12 2,11.7786023 2,11.5054945 C2,11.4094663 2.02583036,11.3155156 2.07433742,11.2351129 L5.09080593,6.23517923 C5.22600272,6.07839308 5.36239198,6 5.49997371,6 C5.63755544,6 5.7739447,6.07839308 5.9091415,6.23517923 L8.92561,11.2351129 C9.06356593,11.4637812 9.00414566,11.7702073 8.79289111,11.919535 C8.71861133,11.9720404 8.63181521,12 8.54309981,12 L7,12 L7,16 Z M17,9 L10.134485,9 C9.92187843,9 9.72338016,8.8563659 9.6056845,8.61735792 L8.53539056,6.44388121 C8.51231174,6.39701438 8.5,6.34199095 8.5,6.28571429 C8.5,6.12791864 8.59476225,6 8.71165741,6 L17.8753337,6 L19.1246663,6 C19.6080998,6 20,6.35698226 20,6.79734219 L20,13 L21.5431524,13 C21.7954624,13 22,13.2213977 22,13.4945055 C22,13.5905337 21.9741696,13.6844844 21.9256626,13.7648871 L18.9091941,18.7648208 C18.7739973,18.9216069 18.637608,19 18.5000263,19 C18.3624446,19 18.2260553,18.9216069 18.0908585,18.7648208 L15.07439,13.7648871 C14.9364341,13.5362188 14.9958543,13.2297927 15.2071089,13.080465 C15.2813887,13.0279596 15.3681848,13 15.4569002,13 L17,13 L17,9 Z",
    id: "Combined-Shape",
    fill: "#858199",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRepost);
export default __webpack_public_path__ + "static/media/iconRepost.c0db52c6.svg";
export { ForwardRef as ReactComponent };